var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconsettingscommunityUsers = function SvgIconsettingscommunityUsers(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Settings/CareGroup") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Settings/CareGroup",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.75,0 C18.2393458,0 23.5,5.26065419 23.5,11.75 C23.5,18.2393458 18.2393458,23.5 11.75,23.5 C5.26065419,23.5 0,18.2393458 0,11.75 C0,5.26065419 5.26065419,0 11.75,0 Z",
    id: "Path_508",
    fill: "#D9E8E3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons/care_group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.583,-1.77635684e-15 C17.9801143,-1.77635684e-15 23.166,5.18588574 23.166,11.583 C23.166,17.9801143 17.9801143,23.166 11.583,23.166 C5.18588574,23.166 -3.71258579e-13,17.9801143 -3.71258579e-13,11.583 C-3.71258579e-13,5.18588574 5.18588574,-1.77635684e-15 11.583,-1.77635684e-15 Z",
    id: "Path_510"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.000000, 5.000000)",
    fill: "#FFFFFF",
    stroke: "#09BE86"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3,
    cy: 3,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11,
    cy: 3,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3,
    cy: 11,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11,
    cy: 11,
    r: 3
  })))))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconsettingscommunityUsers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.settings.community_users.6614973d0250d4d4524aea27d41b3af1.svg";